export default "__VITE_ASSET__3eabfd27__"